import bem from "easy-bem";
import { useTexts } from "hooks/useTexts";
import React from "react";
import { ReactComponent as BellIcon } from "static/icons/notifications-bell.svg";
import CountBadge from "ui/CountBadge";

import "./NotificationButton.css";

const cn = bem("notification-button");

type NotificationButtonProps = {
  count: number;
};

const NotificationButton: React.FC<NotificationButtonProps> = ({ count }) => {
  const { txt } = useTexts("site_menu");

  const label = txt("notifications", "Уведомления");

  return (
    <a
      className={cn()}
      // ?tab=profile — Личное (не Модераторское/Редакторское, см.
      // profile-role-tabs); ?subtab=notifications — читается UserContent,
      // чтобы сразу открыть вкладку "Уведомления" внутри неё.
      href="/#/profile?tab=profile&subtab=notifications"
      aria-label={count > 0 ? `${label}: ${count}` : label}
    >
      {/* Иконка вставляется инлайном, а не через img: в svg используется
          currentColor, чтобы цвет наследовался от шапки */}
      <BellIcon className={cn("icon")} />

      <span className={cn("badge")}>
        <CountBadge count={count} />
      </span>
    </a>
  );
};

export default NotificationButton;
